import React from 'react';
import { FormBuilder } from 'commons-ui';
import useCreate from './useAction';

import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG } from '../../helper';

const BulkActions: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useCreate();

	return (
		<FormBuilder
			data={data}
			mode='bulkActions'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			setShowLoader={setShowLoader}
			fieldConfig={FORM_FIELD_CONFIG}
			layoutConfig={FORM_LAYOUT_CONFIG}
		/>
	);
};

export default BulkActions;
